// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AgbRouteImport } from './routes/agb'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as SoArbeitenWirRouteImport } from './routes/so-arbeiten-wir'
import { Route as UeberUnsRouteImport } from './routes/ueber-uns'
import { Route as WebseitencheckRouteImport } from './routes/webseitencheck'
import { Route as BranchenIndexRouteImport } from './routes/branchen.index'
import { Route as BranchenSlugRouteImport } from './routes/branchen.$slug'
import { Route as LeistungenIndexRouteImport } from './routes/leistungen.index'
import { Route as LeistungenSlugRouteImport } from './routes/leistungen.$slug'
import { Route as NetzwerkIndexRouteImport } from './routes/netzwerk.index'
import { Route as NetzwerkErecht24RouteImport } from './routes/netzwerk.erecht24'
import { Route as RatgeberIndexRouteImport } from './routes/ratgeber.index'
import { Route as RatgeberSlugRouteImport } from './routes/ratgeber.$slug'
import { Route as ReferenzenIndexRouteImport } from './routes/referenzen.index'
import { Route as ReferenzenIdRouteImport } from './routes/referenzen.$id'
import { Route as WebdesignCityRouteImport } from './routes/webdesign.$city'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AgbRoute = AgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const SoArbeitenWirRoute = SoArbeitenWirRouteImport.update({
            id: '/so-arbeiten-wir',path: '/so-arbeiten-wir',getParentRoute: () => rootRouteImport
          })
const UeberUnsRoute = UeberUnsRouteImport.update({
            id: '/ueber-uns',path: '/ueber-uns',getParentRoute: () => rootRouteImport
          })
const WebseitencheckRoute = WebseitencheckRouteImport.update({
            id: '/webseitencheck',path: '/webseitencheck',getParentRoute: () => rootRouteImport
          })
const BranchenIndexRoute = BranchenIndexRouteImport.update({
            id: '/branchen/',path: '/branchen/',getParentRoute: () => rootRouteImport
          })
const BranchenSlugRoute = BranchenSlugRouteImport.update({
            id: '/branchen/$slug',path: '/branchen/$slug',getParentRoute: () => rootRouteImport
          })
const LeistungenIndexRoute = LeistungenIndexRouteImport.update({
            id: '/leistungen/',path: '/leistungen/',getParentRoute: () => rootRouteImport
          })
const LeistungenSlugRoute = LeistungenSlugRouteImport.update({
            id: '/leistungen/$slug',path: '/leistungen/$slug',getParentRoute: () => rootRouteImport
          })
const NetzwerkIndexRoute = NetzwerkIndexRouteImport.update({
            id: '/netzwerk/',path: '/netzwerk/',getParentRoute: () => rootRouteImport
          })
const NetzwerkErecht24Route = NetzwerkErecht24RouteImport.update({
            id: '/netzwerk/erecht24',path: '/netzwerk/erecht24',getParentRoute: () => rootRouteImport
          })
const RatgeberIndexRoute = RatgeberIndexRouteImport.update({
            id: '/ratgeber/',path: '/ratgeber/',getParentRoute: () => rootRouteImport
          })
const RatgeberSlugRoute = RatgeberSlugRouteImport.update({
            id: '/ratgeber/$slug',path: '/ratgeber/$slug',getParentRoute: () => rootRouteImport
          })
const ReferenzenIndexRoute = ReferenzenIndexRouteImport.update({
            id: '/referenzen/',path: '/referenzen/',getParentRoute: () => rootRouteImport
          })
const ReferenzenIdRoute = ReferenzenIdRouteImport.update({
            id: '/referenzen/$id',path: '/referenzen/$id',getParentRoute: () => rootRouteImport
          })
const WebdesignCityRoute = WebdesignCityRouteImport.update({
            id: '/webdesign/$city',path: '/webdesign/$city',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AgbRoute: AgbRoute,DatenschutzRoute: DatenschutzRoute,ImpressumRoute: ImpressumRoute,KontaktRoute: KontaktRoute,SoArbeitenWirRoute: SoArbeitenWirRoute,UeberUnsRoute: UeberUnsRoute,WebseitencheckRoute: WebseitencheckRoute,BranchenSlugRoute: BranchenSlugRoute,LeistungenSlugRoute: LeistungenSlugRoute,NetzwerkErecht24Route: NetzwerkErecht24Route,RatgeberSlugRoute: RatgeberSlugRoute,ReferenzenIdRoute: ReferenzenIdRoute,WebdesignCityRoute: WebdesignCityRoute,BranchenIndexRoute: BranchenIndexRoute,LeistungenIndexRoute: LeistungenIndexRoute,NetzwerkIndexRoute: NetzwerkIndexRoute,RatgeberIndexRoute: RatgeberIndexRoute,ReferenzenIndexRoute: ReferenzenIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)